/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Checkingupdate1Inputs */

const tr_updates_checkingupdate1 = /** @type {(inputs: Updates_Checkingupdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni bir sürüm tespit edildi. Güncel sürümün yüklenmesi önerilir.`)
};

const en_updates_checkingupdate1 = /** @type {(inputs: Updates_Checkingupdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version has been detected. It is recommended to install the latest version.`)
};

/**
* | output |
* | --- |
* | "A new version has been detected. It is recommended to install the latest version." |
*
* @param {Updates_Checkingupdate1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_checkingupdate1 = /** @type {((inputs?: Updates_Checkingupdate1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Checkingupdate1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_checkingupdate1(inputs)
	return en_updates_checkingupdate1(inputs)
});
export { updates_checkingupdate1 as "updates_checkingUpdate" }